export enum PaginationSize {
   Small = "small",
   Normal = "normal",
   Large = "large"
}
